module.exports = __webpack_public_path__ + "static/media/down.5c2491e6.svg";